export default "__VITE_ASSET__CldxxrAH__"